module.exports = __webpack_public_path__ + "static/media/DSC_0412.bd87a0fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0412.jpg
// module id = 600
// module chunks = 0